export const rules ={
  shares: [
    { required: true, message: "认购份额", trigger: "change" },
  ],
  amount: [
    { required: true, message: "认购价格", trigger: "change" },
  ]
  
    }
    


